// extracted by mini-css-extract-plugin
module.exports = {"mainBlockContainer":"DashboardLayout_mainBlockContainer__CAqup","mainBlock":"DashboardLayout_mainBlock__1YIkZ"};